import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import './select/component'

import './component.scss'

const app = Application.start()

app.register('pickup-services', class extends Controller {
  static targets = ["prefecture", "city", "floor", "paint", "button"]

  connect() {
    this.checkState();
  }

  /**
   * 全てのselect要素の変更時に実行する
   * @param {Event} event - changeイベントオブジェクト
   */
  async checkState(event) {
    if (event && event.currentTarget === this.prefectureTarget) {
      await this.updateCities();
    }

    const prefectureSelected = this.prefectureTarget.value !== "0";
    const citySelected = this.cityTarget.value !== "0";
    const floorSelected = this.floorTarget.value !== "0";
    const paintSelected = this.paintTarget.value !== "0";

    // 後続の要素の有効/無効を切り替え
    this.cityTarget.disabled = !prefectureSelected;
    this.floorTarget.disabled = !citySelected && this.floorTarget.value === "0";
    this.paintTarget.disabled = !floorSelected;

    // リンクの有効/無効を切り替え
    const allSelected = prefectureSelected && citySelected && floorSelected && paintSelected;
    this.buttonTarget.classList.toggle('disabled', !allSelected);
    this.buttonTarget.setAttribute('aria-disabled', !allSelected);

    this._updateButtonHref();
  }

  /**
   * 市区町村リストをAPIから取得して更新する
   */
  async updateCities() {
    this._clearCityOptgroups();

    const selectedOption = this.prefectureTarget.selectedOptions[0];
    const prefectureName = selectedOption?.textContent;

    if (!prefectureName || this.prefectureTarget.value === "") {
      return; // 未選択状態なら何もしない
    }

    try {
      const response = await fetch(`/api/prefecture/${encodeURIComponent(prefectureName)}/cities`);
      if (!response.ok) {
        throw new Error("API request failed.");
      }
      const cities = await response.json();
      this._populateCities(cities);
    } catch {

    }
  }

  /**
   * 市区町村のoptgroupとoptionを生成する
   */
  _populateCities(cities) {
    const grouped = cities.reduce((acc, city) => {
      const initial = city.yomi[0];
      if (!acc[initial]) {
        acc[initial] = [];
      }
      acc[initial].push(city);
      return acc;
    }, {});

    Object.keys(grouped).sort().forEach(initial => {
      const optgroup = document.createElement('optgroup');
      optgroup.label = initial;
      grouped[initial].forEach(city => {
        const option = document.createElement('option');
        option.value = city.id;
        option.textContent = city.name;
        optgroup.appendChild(option);
      });
      this.cityTarget.appendChild(optgroup);
    });
  }

  /**
   * 市区町村select内のoptgroupを全て削除する
   */
  _clearCityOptgroups() {
    this.cityTarget.querySelectorAll('optgroup').forEach(group => group.remove());
  }

  /**
   * CTAリンクのhref属性を、現在の選択内容に応じて更新する
   */
  _updateButtonHref() {
    const url = new URL(this.buttonTarget.href);

    const paramsToUpdate = {
      prefecture: { element: this.prefectureTarget, key: 'prefecture' },
      city:       { element: this.cityTarget,       key: 'city' },
      floor:      { element: this.floorTarget,      key: 'floor_square_meter' },
      paint:      { element: this.paintTarget,      key: 'paint' },
    };

    for (const targetName in paramsToUpdate) {
      const { element, key } = paramsToUpdate[targetName];
      const selectedOption = element.selectedOptions[0];

      if (selectedOption) {
        if (element.value) {
          url.searchParams.set(key, selectedOption.textContent);
        } else {
          url.searchParams.delete(key);
        }
      }
    }

    this.buttonTarget.href = url.href;
  }
})
